module.exports = __webpack_public_path__ + "img/blockwell.a930d44d.png";